import * as React from 'react';
import { useRouter } from 'next/router';
import { ReferralCampaignType } from 'model/referralCampaign';
import useUserReferralCampaigns from 'hooks/api/useUserReferralCampaigns';
import { DateTime } from 'luxon';
import { getSessionStorageItem, SessionStorageKey } from 'utils/storage';
import { LUXON_MIDNIGHT } from 'utils/date';
import { Referral } from 'model/referralCampaign';
import { useLoyalty } from 'contexts/loyalty';

export const useCreditCardApplicationUrl = (appliedCampaign?: Referral) => {
  const { userBalance } = useLoyalty();
  const { swissLoyaltyId } = userBalance || {};
  const { locale } = useRouter();
  const { userReferralCampaigns } = useUserReferralCampaigns();
  const utmParams = getSessionStorageItem(SessionStorageKey.GA_QUERY_PARAMS);

  const existingCampaigns = React.useMemo(() => {
    const includesAppliedCampaign =
      appliedCampaign && !!userReferralCampaigns.find(camp => camp.id === appliedCampaign.id);

    return !includesAppliedCampaign && appliedCampaign
      ? [appliedCampaign, ...userReferralCampaigns]
      : userReferralCampaigns;
  }, [appliedCampaign, userReferralCampaigns]);

  const promoCode = React.useMemo(() => {
    if (existingCampaigns?.length) {
      const codes = existingCampaigns?.map(camp => {
        const {
          type,
          endDate: rawEndDate,
          startDate: rawStartDate
        } = camp.referralLink.campaign || {};

        const endDate = DateTime.fromISO(rawEndDate as any);
        const startDate = DateTime.fromISO(rawStartDate as any);
        const expired = endDate.set(LUXON_MIDNIGHT).diffNow('days').days < 0;
        const started = startDate.diffNow('days').days < 0;
        const active = started && !expired;

        if (type === ReferralCampaignType.SWISSCARD && active) {
          return camp.referralLink.code;
        }
      });

      const code = codes.find(code => !!code);
      return code;
    } else {
      return;
    }
  }, [existingCampaigns]);

  const url = new URL('https://swissloyaltycards.poinz.ch');

  if (utmParams) {
    Object.entries(utmParams).forEach(([key, value]: any) => {
      url.searchParams.append(key, value);
    });
  }

  if (locale) {
    url.searchParams.append('locale', locale);
  }

  if (swissLoyaltyId) {
    url.searchParams.append('swissLoyaltyNumber', swissLoyaltyId);
    if (promoCode) {
      url.searchParams.append('promoCode', promoCode);
    }
  }
  return url.toString();
};
